import { Controller } from "@hotwired/stimulus"

export default class UsageUpdateModalController extends Controller {
  static targets = ["btnCancel", "btnUpdate"]
  static values = {
    usage: Object
  }

  handleUsageChange() {
    this.usageValue = {...this.usageValue, usageValue: event.target.value}
  }

  close() {
    this.btnUpdateTarget.disabled = false
    this.btnCancelTarget.disabled = false
    this.element.close()
  }

  submit() {
    this.btnUpdateTarget.disabled = true
    this.btnCancelTarget.disabled = true

    let dashboard = document.getElementById("dashboard")
    let csrfToken = document.querySelector("meta[name='csrf-token']").content
    let url = `/admin/usages/${this.usageValue.usageId}`
    fetch(url, {
      method: "PATCH",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify(this.usageValue)
    })
      .then (response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
        this.close()
      });
  }
}
